module.exports = __webpack_public_path__ + "static/media/1_5.78e95c47.png";